var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import Accordioncommon from "@frameworks/web/components/generic/Accordion/accordion";
import React, { useState } from "react";
import Timingdata from "./Timingdata";
import Emailidimg from "../../../../../assets/images/features/BasicProfile/Emailid.svg";
import callus from "../../../../../assets/images/features/BasicProfile/callus.svg";
import FeedbackData from "./Feedback";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import { Col } from "react-bootstrap";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import GenericDrawer from "@frameworks/web/components/generic/TOCgeneric/GenericDrawer";
import { useNavigate } from "react-router-dom";
var ContactusDataTab = function () {
    var device = DeviceContext();
    var navigate = useNavigate();
    var _a = __read(useState(false), 2), giveFeedback = _a[0], setgiveFeedback = _a[1];
    var ContactDataTab = [
        {
            title: (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "DMSan_16_700 txt_blackOne1" }, "Timings"))),
            eventKey: "FAQs",
            tabContent: (React.createElement(React.Fragment, null,
                React.createElement(Timingdata, null))),
        },
        {
            title: (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "DMSan_16_700 txt_blackOne1" }, "Write to us"),
                React.createElement("span", null,
                    React.createElement("a", { href: "mailto:helpdesk@nuvama.com", className: "txt-midnight-blue DMSan_16_500" },
                        "helpdesk@nuvama.com",
                        React.createElement("span", { className: "ps-2" },
                            React.createElement("img", { src: Emailidimg, alt: "Email Icon" })))))),
            eventKey: "WealthAdvisors",
            tabContent: React.createElement(React.Fragment, null),
        },
        {
            title: (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "DMSan_16_700 txt_blackOne1 " }, "Call us"),
                React.createElement("span", null,
                    React.createElement("div", { className: " d-flex DMSan_16_500 txt-midnight-blue", onClick: function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                        } },
                        React.createElement("div", { className: " txt-midnight-blue mobile-cursor-removed" }, "1800-102-3335"),
                        " ",
                        React.createElement("img", { src: callus, className: "ps-2" }))))),
            eventKey: "ContactUs",
            tabContent: React.createElement(React.Fragment, null),
        },
        {
            title: (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "DMSan_16_700 txt_blackOne1" },
                    "Give us feedback",
                    React.createElement("div", { className: "DMSan_14_500 txt_primaryGrey d-flex mt-2" }, "Your ideas and suggestions will immensely help us improve our services.")))),
            eventKey: "ContactUs",
            tabContent: React.createElement(FeedbackData, null),
        },
    ];
    var ContactDataTabmb = [
        {
            title: (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "DMSan_14_500 txt-secondary-gray d-flex " }, "Timings"))),
            eventKey: "Timings",
            tabContent: (React.createElement(React.Fragment, null,
                React.createElement(Timingdata, null))),
        },
    ];
    return (React.createElement(React.Fragment, null, device && device.isDesktop ? (React.createElement(React.Fragment, null,
        React.createElement(Accordioncommon, { AccordionArray: ContactDataTab, isLink: false, parentClass: "common-accordian-small-content  mt-4 contact-data-tab  small-accordion-background " }))) : (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "bg-white px-3 pt-3 pb-3" },
            React.createElement(Col, { lg: 12, className: "d-flex justify-content-between pb-3 align-items-center" },
                React.createElement("span", { className: "DMSansNormal_20_400  txt-midnight-blue" },
                    React.createElement("span", { className: "d-flex align-items-center mb-title", onClick: function () {
                            navigate("/profile");
                        } },
                        React.createElement("i", { className: "edel-icon-arrow-left1 pe-2" }),
                        "Contact",
                        " ",
                        React.createElement("span", { className: "DMSansNormal_20_700  txt-midnight-blue ps-2" }, "Us")))),
            React.createElement(Col, { lg: 12 },
                React.createElement("div", { className: "border-outer-box contact-data-mb" },
                    React.createElement(Accordioncommon, { AccordionArray: ContactDataTabmb, parentClass: "common-accordian-small-content  small-accordion-background contact-data-tab  welthadvisory-acc-mb" }))),
            React.createElement(Col, { lg: 12, className: "mgt-20" },
                React.createElement("div", { className: "border-outer-box p-3" },
                    React.createElement("span", null,
                        React.createElement("span", { className: "DMSan_14_500 txt_secondary-gray  grid-1 mb-3" }, "Call us"),
                        React.createElement("span", { className: "d-flex DMSan_14_500 justify-content-between mobile-cursor-removed", onClick: function (e) { return e.stopPropagation(); } },
                            React.createElement("span", { className: "d-flex  text-decoration-underline" },
                                "1800-102-3335",
                                " "),
                            React.createElement("span", { className: "d-flex" },
                                React.createElement("img", { src: callus, className: "ps-2" })))))),
            React.createElement(Col, { lg: 12, className: "mgt-20" },
                React.createElement("div", { className: "border-outer-box p-3" },
                    React.createElement("span", null,
                        React.createElement("span", { className: "DMSan_14_500 txt-secondary-gray grid-1 mb-2" }, "Write to us"),
                        React.createElement("span", null,
                            React.createElement("a", { href: "mailto:helpdesk@nuvama.com", className: "txt-midnight-blue DMSan_16_500 d-flex justify-content-between" },
                                React.createElement("span", null, " helpdesk@nuvama.com"),
                                React.createElement("span", { className: "ps-2" },
                                    React.createElement("img", { src: Emailidimg, alt: "Email Icon" }))))))),
            React.createElement(Col, { lg: 12, className: "mgt-20" },
                React.createElement("div", { className: "border-outer-box p-3" },
                    React.createElement("span", { className: "DMSan_14_500 txt-secondary-gray d-flex" }, "Give us feedback"),
                    React.createElement("div", { className: "DMSanN_14_400 txt_primaryGrey d-flex mt-2" }, "Your ideas and suggestions will immensely help us improve our services."),
                    React.createElement("span", { className: "d-flex mt-3 new-dmsan-btn-500" },
                        React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "Give feedback", onClick: function () { return setgiveFeedback(true); } }))))),
        giveFeedback && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "mb-basic-profile" },
                React.createElement(GenericDrawer, { show: giveFeedback, setShow: setgiveFeedback, parentClass: "z-index-high", headerComp: React.createElement(React.Fragment, null,
                        React.createElement("label", { className: "term-heading DMSan_16_700 txt_blackOne1" }, "Feedback")), bodyComp: React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "FeedbackData-mb" },
                            React.createElement(FeedbackData, { goBack: function () { return setgiveFeedback(false); } }))) }))))))));
};
export default ContactusDataTab;
